const  querystring = require('querystring');

export default {
  methods: {
    /**
     * 检查用户令牌是否有效
     * @return {Boolean}
     */
    checkAuth() {
      const queryString = querystring.parse(window.location.search.replace('?', ''));
      let uri = encodeURIComponent(window.location.href);
      let token = queryString.token;
      let user = this.$jwt.user();

      if (!token) {
        if (user !== null) {
          return true;
        }

        if (!this.isWechat()) {
          window.location.href = `http://m.${process.env.VUE_APP_DOMAIN}/login.html?from=${uri}`;

        }

        return false;
      } else {
        this.$jwt.save(token);
      }

      user = this.$jwt.user();
      if (user === null) {
        window.location.href = `http://m.${process.env.VUE_APP_DOMAIN}/login.html?from=${uri}`;
        return false;
      }

      return true;
    },

    isApp() {
      if (navigator.userAgent.match(/uni-app/g)) {
        return true;
      }
      return false;
    },

    // 判断是否是微信环境包括浏览器环境、微信小程序环境
    isWechat() {
      if (navigator.userAgent.match(/MicroMessenger/g)) {
        return true;
      }
      return false;
    },
    
    // 判断是否是微信环境包括浏览器环境、微信、百度小程序、uniapp环境
    isUni() {
      let regUni = /miniProgram|micromessenger|swan|uni-app/g
      if(regUni.test(navigator.userAgent)) {
        return true;
      }
      return false
    },

    // 实现一个全局toast
    toast(string) {
      new ProxySingletonCreateDiv(string);
    },

    setLocaoStorage(key, value) {
      let localStorageKeys = Object.keys(localStorage);

      if (1024 * 1024 * 5 > JSON.stringify(localStorage).length) {
        localStorage.setItem(key, JSON.stringify(value));
      } else {
        localStorageKeys.forEach(item => {
          if (item.indexOf('doc') !== -1 || item.indexOf('new') !== -1) {
            localStorage.removeItem(item);
          }
        })
        localStorage.setItem(key, JSON.stringify(value));
      }
    },

    removeLocalStorage(key) {
      Object.keys(localStorage).forEach((item) => {
        if (item.indexOf(key) !== -1) {
          localStorage.removeItem(item);
        }
      })
    },

    /**
     * 随机生成指定长度的随机字符串，默认32位
     * @param {Number} len 随机字符串的长度
     * @return {String} 指定长度的随机字符串
     */
    generateRandomString(len) {
      len = len || 32;
      let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
      let maxPos = chars.length;
      let pwd = '';
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
  }
}

// 创建一个div并初始化
var CreateDiv = function(string) {
  this.string = string;
  this.init();
}

CreateDiv.prototype.init = function() {
  var div = document.createElement( 'div' );
  div.innerText = this.string;
  div.className = "toast";
  let style = {
    position: 'fixed',
    bottom: '50%',
    left: '50%',
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingTop: '5px',
    paddingBottom: '5px',
    borderRadius: '3px',
    backgroundColor: '#000',
    opacity: 0.7,
    color: '#fff',
    zIndex: '999',
    transform: 'translateX(-50%)',
    fontSize: '14px',
  }
  Object.assign(div.style, style);
  document.body.appendChild(div);
  isShow(div);
}

var ProxySingletonCreateDiv = (function(){
  var instance;
  return function(string){
    var toast = document.getElementsByClassName('toast')[0];
    if (toast && (toast.style.display === 'none')) {
      toast.innerText = string;
      toast.style.display = 'block';
      isShow(toast)
    }
    if (!instance){
      instance = new CreateDiv(string);
    }
    return instance;
  }
})();

// 控制toast
function isShow(dom) {
  setTimeout(() => {
    dom.style.display = 'none';
  }, 3000)
}
